import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import * as React from "react";
import GetAllRoleLists from "components/mnl/role/getAllRoleLists";
import MenuBar from "components/mnl/global/menuBar";
import { theme } from "components/mnl/global/theme";
import V2sessionTimeout from "components/mnl/global/v2SessionTimeout";
import TableLayout from "views/mnl/layout/tableLayout";

const RolePage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <MenuBar pageName={"Role"} />
        <TableLayout>
          <GetAllRoleLists />
        </TableLayout>
      </Box>
      <V2sessionTimeout />
    </ThemeProvider>
  );
};
export default RolePage;
